import { useSelector } from 'react-redux';
import BaseTable from '../../components/BaseTable';
import { fetchPharmacyProfilesList } from '../../api/careRecords';
import { CARE_TABLE_KIND, useTableColumns } from '../../hooks/columns';
import { useCareList } from '../../hooks/useCareList';

export default function Pharmacy() {
  const token = useSelector((state) => state.auth.token);
  const columns = useTableColumns(CARE_TABLE_KIND.pharmacy);
  const { data, loading, error } = useCareList(fetchPharmacyProfilesList, token);

  return (
    <div className="care-page">
      <BaseTable
        columns={columns}
        dataSource={data}
        loading={loading}
        error={error}
        searchKeys={[
          'id',
          'store_name',
          'tagline',
          'address',
          'district',
          'state',
          'phone'
        ]}
        searchPlaceholder="Search store, address, location, phone…"
        emptyText="No pharmacy profiles found."
      />
    </div>
  );
}
